"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @class
 * @description Feature toggle for components.
 * @todo Create preview
 */
var FeatureToggle =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FeatureToggle, _React$Component);

  function FeatureToggle(props, context) {
    var _this;

    _classCallCheck(this, FeatureToggle);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FeatureToggle).call(this, props, context));
    var query = '*[_type == "client" && name == $name] {features[]{feature->,...}}';
    var params = {
      name: props.client
    };
    props.sanityClient.fetch(query, params).then(function (result) {
      if (!result || !result.length) {
        return null;
      }

      console.log(result);
      var client = result[0];
      console.log(client, props.feature);
      var feature = client.features.find(function (f) {
        return f.feature.name === props.feature;
      });
      console.log(feature);

      if (feature) {
        console.log("found feature", feature);

        _this.setState({
          show: !!feature[props.environment]
        });
      }
    });
    _this.state = {
      show: false
    };
    return _this;
  }

  _createClass(FeatureToggle, [{
    key: "render",
    value: function render() {
      var type = _typeof(this.props.children);

      if (type === "function") {
        // If render props, send state and let client handle it
        return this.props.children(_objectSpread2({}, this.state));
      }

      var show = this.state.show;

      if (!show) {
        return null;
      }

      return this.props.children;
    }
  }]);

  return FeatureToggle;
}(_react["default"].Component);

FeatureToggle.propTypes = {
  /**
   * React element or render prop
   * Render prop will return the state, so the decision to not render is with the app
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),

  /**
   * Client in the cms
   * @example Aprila
   */
  client: _propTypes["default"].string.isRequired,

  /**
   * NODE_ENV should be used here
   */
  environment: _propTypes["default"].oneOf(["dev", "staging", "production"]),

  /**
   * Name of feature. This is defined in Sanity and must match
   * @example "savings-account"
   */
  feature: _propTypes["default"].string.isRequired,

  /**
   * Sanity client to be used for fetching the feature
   * Must be @sanity/client
   */
  sanityClient: _propTypes["default"].any.isRequired
};
FeatureToggle.defaultProps = {
  environment: "production"
};
var _default = FeatureToggle;
exports["default"] = _default;